import React from 'react';
import { NoticeContentWithUrl } from '@bld/bld-libs/components';
import { NoticeDetail } from '../../modals/common';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import moment from 'moment';
import _ from 'lodash';
import NotificationService from '../../../services/Notification';
import { messageUtility } from '../../../utilities/messageUtility';

/**
 * Buildeeからのお知らせ ページ
 */
export class NoticeFromBuildee extends React.Component {
  defaultState = {
    notices: [],
    modelDetailVisible: false,
    modelDetailTitle: '',
    modelDetailDate: '',
    modelDetailMessage: '',
  };

  constructor(props) {
    super(props);

    this.state = { ...this.defaultState };

    this.handleClickConfirm = this.handleClickConfirm.bind(this);
    this.handleClickClose = this.handleClickClose.bind(this);
  }

  componentDidMount() {
    this.getNotifications();
  }

  handleInview(notify = () => {}) {
    if (this.state.loaded) {
      this.setState({
        loaded: false,
      });
      this.setNotifications(notify);
    } else {
      notify();
    }
  }

  getNotifications(notify = () => {}) {
    if (this.state.loaded) {
      notify();
      this.setState({ isLoading: false });
      return;
    }
    const pageParam = {
      offset: _.size(this.state.notices),
      order: 'display_start_date_desc',
    };

    const params = _.assign(pageParam);
    NotificationService.systemList(params).then(response => {
      if (response.result) {
        const getNotices = response.data.entities.notices;
        if (_.isEmpty(getNotices)) {
          this.setState({
            loaded: false,
          });
          notify();
        } else {
          const notices = _.cloneDeep(this.state.notices);
          let noticeDate, todaysDate, dateDiff, days_passed;
          _.each(getNotices, notice => {
            //経過日数計算
            noticeDate = Date.parse(notice.display_start_date.slice(0, 10));
            todaysDate = Date.parse(moment().format('YYYY/MM/DD'));
            dateDiff = todaysDate - noticeDate;
            days_passed = Math.floor(dateDiff / (1000 * 60 * 60 * 24));

            //経過日数カラム追加
            notice.days_passed = days_passed;

            notices.push(notice);
            // console.log('NoticeFromBuildee.jsx getNotifications', notice);
          });
          this.setState({
            notices,
            total: response.data.total,
            loaded: true,
          });
          notify();
        }
        this.setState({ isLoading: false });
      }
    });
  }

  handleClickConfirm = notice => {
    // console.log('NoticeFromBuildee.jsx handleClickConfirm', notice);

    this.setState({
      modalDetailVisible: true,
      modalDetailTitle: notice.title,
      modalDetailDate: moment(
        notice.display_start_date,
        'YYYY/MM/DD HH:mm:ss'
      ).format('YYYY/MM/DD HH:mm'),
      modalDetailMessage: notice.content,
    });
  };

  handleClickClose = () => {
    this.setState({
      modalDetailVisible: false,
      modalDetailTitle: this.defaultState.modalDetailTitle,
      modalDetailDate: this.defaultState.modalDetailDate,
      modalDetailMessage: this.defaultState.modalDetailMessage,
    });
  };

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <div
          className='information-slide-view__body'
          id='infinityscroll-target'
        >
          <table className='table'>
            <tbody>
              {this.state.notices.map((notice, index) => {
                return (
                  <NoticeItem
                    key={index}
                    index={index}
                    notice={notice}
                    onClickConfirm={this.handleClickConfirm}
                  />
                );
              })}
              {}
            </tbody>
          </table>
          <InfinityScrollLoad
            targetId='infinityscroll-target'
            total={_.size(this.state.notices)}
            isLoading={this.state.isLoading}
            callback={this.handleInview}
          />
        </div>
        <NoticeDetail
          visible={this.state.modalDetailVisible}
          title={this.state.modalDetailTitle}
          date={this.state.modalDetailDate}
          message={this.state.modalDetailMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={this.handleClickClose}
        />
      </React.Fragment>
    );
  }
}

// eslint-disable-next-line no-unused-vars
const NoticeItem = ({ index, notice, onClickConfirm }) => (
  <tr className='table__item'>
    <td className='value-information-table__date'>
      {moment(notice.display_start_date, 'YYYY/MM/DD HH:mm:ss').format(
        'YYYY/MM/DD HH:mm'
      )}
    </td>
    <td className='value-information-table__description'>
      <div className='information-description-item'>
        <div className='information-description-item__header'>
          <div className='information-description-item__title information-description-item__title--truncated'>
            {notice.title}
          </div>
          <div className='information-description-item__time'>
            {notice.days_passed}日経過
          </div>
        </div>
        <div className='information-description-item__body'>
          <div className='notification-description-item__info notification-description-item__info--truncated'>
            <NoticeContentWithUrl
              content={notice.content}
              urlClassName='clickable-text'
            />
          </div>
        </div>
      </div>
    </td>
    <td className='value-information-table__button'>
      <button className='btn-text--mini' onClick={() => onClickConfirm(notice)}>
        確認
      </button>
    </td>
  </tr>
);



// WEBPACK FOOTER //
// ./src/components/ManualContact/page/NoticeFromBuildee.jsx